import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import softwareDetailsActions from '../actions/softwareDetails';
import businessModelActions from '../actions/businessModel';
import {DEEP_LINK_PARAM_TYPE, removeDeepLinkParams} from '../utils/localStorageDataHandler';
import {isPPM} from '../utils/validate';
import { MERCHANT_OF_RECORD, USER_TYPE } from "../utils/constants";
import helpActions from "../actions/help";

const dispatchServiceError = (store, errorKey) => {
    store.dispatch(softwareDetailsActions.alertError(errorKey));
    store.dispatch(actions.enableLoadOverLay(false));
};

function sendIneligibleEmail(store, ineligibilityType) {
    const state = store.getState();
    const userInfo = state.userInfoDetails && state.userInfoDetails.userInfoMetadata;
    const data = userInfo && userInfo.user ? {
        firstName: userInfo.user.firstName,
        lastName: userInfo.user.lastName,
        emailAddress: userInfo.user.emailAddress,
        companyName: userInfo.user.companyName,
        message: ineligibilityType
    } : {
        message: ineligibilityType
    };
    const helpFormData = {
        data,
        type: 'INELIGIBLE'
    };
    store.dispatch(helpActions.submitHelpForm(helpFormData));
}

function validateBusinessModelCompatibility(store, systemId) {
    const state = store.getState();
    const userType = state.app?.userType;
    const currency = state.userInfoDetails?.userInfoMetadata?.billingCurrencyCode;

    if (currency === 'USD' || state.app?.dyff?.SHARED_ROW_MOR_ENABLED) {
        if (userType === USER_TYPE.IPM_SOFTWARE_SWITCH) {
            const advertiserBusinessModel = store.getState().businessModel?.advertiserBusinessModel;
            return new Promise((resolve) => {
                request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?systemId=${systemId}`)
                    .end((error, response) => {
                        if (error) {
                            store.dispatch(actions.enableLoadOverLay(false));
                            store.dispatch(softwareDetailsActions.alertError('ipmob.internal.server.error'));
                            resolve(true); // stop further processing
                            return;
                        }

                        try {
                            const { businessModel: preferredBusinessModel } = JSON.parse(response.text);

                            if (!preferredBusinessModel) {
                                store.dispatch(actions.enableLoadOverLay(false));
                                store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
                                resolve(true); // stop further processing
                                return;
                            }

                            if (advertiserBusinessModel === MERCHANT_OF_RECORD.EG) {
                                // IPM = MOR
                                if (preferredBusinessModel === MERCHANT_OF_RECORD.SUPPLIER) {
                                    // PMSC supports Agency only → Ineligible
                                    store.dispatch(actions.enableLoadOverLay(false));
                                    store.dispatch(actions.showIneligibleForm('UNSUPPORTED_AGENCY_TO_MOR_SWITCH'));
                                    sendIneligibleEmail(store, 'UNSUPPORTED_AGENCY_TO_MOR_SWITCH');
                                    resolve(true); // ineligible, stop further processing
                                    return;
                                }
                            }
                            resolve(false); // eligible, continue
                        } catch (exp) {
                            store.dispatch(actions.enableLoadOverLay(false));
                            store.dispatch(softwareDetailsActions.alertError('ipmob.error.process.request'));
                            resolve(true); // stop further processing
                        }
                    });
            });
        }
    }
    return Promise.resolve(false); // no check needed, continue
}

async function validateSoftwareDetails(store, action) {
    const softwareDetails = action.payload.softwareDetails;
    const isIneligible = await validateBusinessModelCompatibility(store, softwareDetails.systemId);
    if (isIneligible) return;
    request.post(`/${config.url_prefix}/api/advertiser/externalId/validate`)
        .send({
            data: softwareDetails
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                dispatchServiceError(store, 'ipmob.internal.server.error');
            } else {
                try {
                    const parsedResponse = response.text ? JSON.parse(response.text) : {};

                    if (parsedResponse === 0 || parsedResponse === 1) {
                        removeDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams); // remove PMSC params from local storage
                        if (store.getState().app.dyff?.SHARED_IPM_BANKING_ENABLED) {
                            store.dispatch(businessModelActions.resolveBusinessModel(softwareDetails.systemId, softwareDetails.softwareId));
                        } else if (isPPM(store.getState().app.userType)) {
                            store.dispatch(actions.changeAppState('LISTING_MODEL'));
                        } else {
                            store.dispatch(actions.changeAppState('CURRENCY_DETAILS'));
                        }
                    } else if (parsedResponse.code === 409 || parsedResponse.code === 400) {
                        dispatchServiceError(store, 'ipmob.software_details.invalid');
                    } else if (parsedResponse.code === 403) {
                        store.dispatch(actions.showIneligibleForm('NO_SOFTWARE_INELIGIBILTY'));
                    } else {
                        dispatchServiceError(store, 'ipmob.error.process.request');
                    }
                } catch (e) {
                    dispatchServiceError(store, 'ipmob.error.process.request');
                }
            }
        });
}

export default validateSoftwareDetails;
